// import React from "react";
// import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

// // Images
// import logo from "../images/Helix logo.jpg";
// import webIcon from "../images/web.jpg";
// import phoneIcon from "../images/phone icon.jpg";
// import locationIcon from "../images/location icon.jpg";
// import messageIcon from "../images/message.jpg";

// const TermsConditions = () => (
//   <Page size="A4" style={styles.page}>
//     {/* Header */}
//     <View style={styles.header}>
//       <Image src={logo} style={styles.logo} />
//       <View style={styles.headerRight}>
//         <Image src={webIcon} style={styles.iconSmall} />
//         <Text style={styles.website}>sbsgroups.co.in</Text>
//       </View>
//     </View>

//     {/* Body (table + terms) */}
//     <View style={styles.body}>
//       {/* Quotation Summary Table */}
//       <View style={styles.table}>
//         {[
//           ["Basic Rate for Pit 01", "4,80,000 INR"],
//           ["Basic Rate for Pit 02", "4,44,000 INR"],
//           ["Basic Rate for Pit 03", "4,48,000 INR"],
//           ["Packing & Forwarding", "2,500 INR"],
//           ["GST 18%", "2,47,410 INR"],
//           ["Grand Total", "16,21,910 INR"],
//         ].map(([label, value], i) => (
//           <View key={i} style={styles.row}>
//             <Text style={styles.cellLabel}>{label}</Text>
//             <Text style={styles.cellValue}>{value}</Text>
//           </View>
//         ))}
//       </View>

//       {/* Terms & Conditions */}
//       <Text style={styles.sectionTitle}>Terms & Conditions</Text>
//       <View style={styles.list}>
//         {terms.map((t, i) => (
//           <View key={i} style={styles.listItem}>
//             <Text style={styles.bullet}>•</Text>
//             <Text style={styles.listText}>{t}</Text>
//           </View>
//         ))}
//       </View>
//     </View>

//     {/* Footer pinned at bottom */}
//     <View style={styles.footer}>
//       {/* Phone */}
//       <View style={styles.footerSection}>
//         <Image src={phoneIcon} style={styles.icon} />
//         <View>
//           <Text style={styles.footerText}>8827559628</Text>
//           <Text style={styles.footerText}>9826808412</Text>
//         </View>
//       </View>

//       {/* Location */}
//       <View style={[styles.footerSection, styles.footerCenter]}>
//         <Image src={locationIcon} style={styles.icon} />
//         <Text style={styles.footerText}>
//           Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
//         </Text>
//       </View>

//       {/* Email */}
//       <View style={[styles.footerSection, styles.footerRight]}>
//         <Image src={messageIcon} style={styles.icon} />
//         <View>
//           <Text style={styles.footerText}>info@sbsgroups.co.in</Text>
//           <Text style={styles.footerText}>sales@sbsgroups.co.in</Text>
//         </View>
//       </View>
//     </View>
//   </Page>
// );

// const terms = [
//   "Offer validity: 30 Days from the date of submission, thereafter it will be subject to confirmation by us.",
//   "Prices: Quoted prices are Ex works. (our kathwada factory only)",
//   "Taxes: 18% GST applicable",
//   "P&F: 2% of basic amount",
//   "Transportation: Transportation charges will be in client scope, we are not responsible for damages if arranged by client.",
//   "Transit Insurance to be borne by client.",
//   "Payment Terms: 50% advance of total amount with GST along with PO, 50% of total amount against material readiness and Dispatch. (100% GST will be paid before dispatch)",
//   "Delivery period: 10 to 12 weeks from PO date and advance Payment received & Drawing Approval.",
//   "Installation: 3000/- Per Day, on-site civil work, Electric work, welding machine, drilling machine, hydra/fork lift, soft labor required will be in client scope.",
//   `Warranty: 
//    a) 12 months from the date of Invoice, we hereby warranty to replace free of cost Ex. Works Kathwada, any component found defective due to any manufacturing defects only. Bad workmanship will not be considered.
//    b) Warranty of bought-out product will remain the same as per company terms.
//    c) No warranty/Guarantee provided for electrical components. If any electrical failure occurs and due to this if any mechanical component fails, the same shall not be covered under warranty/guarantee and will be supplied only on chargeable basis.
//    d) In battery-operated equipment, battery charger will not be covered under warranty. Battery warranty will be 12 months.,
//    e) Once Order Placed not cancelled for any reason, if cancelled En􀆟re advance
// amount will be forfeited.
//  Civil Work Scope: Pit Alignment with Plaster in client Scope.
//  Electric work: Point for Panel & Underground wiring for Remote in Client
// Scope`
// ];


// const styles = StyleSheet.create({
//   page: {
//     padding: 25,
//     fontSize: 9,
//     fontFamily: "Helvetica",
//     backgroundColor: "#fff",
//     flexDirection: "column",
//   },
//   header: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     borderBottom: "2pt solid #b20000",
//     paddingBottom: 6,
//     marginBottom: 12,
//   },
//   logo: { width: 80, height: 80 },
//   headerRight: { flexDirection: "row", alignItems: "center" },
//   website: { fontSize: 11, color: "#b20000", fontWeight: "bold", marginLeft: 5 },

//   body: {
//     flex: 1, // ✅ ensures body stretches
//     justifyContent: "flex-start",
//   },
//   table: {
//     border: "1pt solid #000",
//     marginBottom: 12,
//   },
//   row: { flexDirection: "row", borderBottom: "1pt solid #000" },
//   cellLabel: {
//     width: "70%",
//     padding: 5,
//     borderRight: "1pt solid #000",
//     fontWeight: "bold",
//   },
//   cellValue: { width: "30%", padding: 5, textAlign: "right" },
//   sectionTitle: {
//     fontSize: 11,
//     fontWeight: "bold",
//     marginVertical: 8,
//   },
//   list: { flexDirection: "column" },
//   listItem: { flexDirection: "row", marginBottom: 4 },
//   bullet: { marginRight: 4, fontSize: 10 },
//   listText: { flex: 1, fontSize: 9, textAlign: "justify" },

//   footer: {
//     flexDirection: "row",
//     backgroundColor: "#b20000",
//     color: "#fff",
//     padding: 8,
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   footerSection: { flexDirection: "row", alignItems: "center", width: "30%" },
//   footerCenter: { width: "40%", textAlign: "center" },
//   footerRight: { justifyContent: "flex-end", textAlign: "right" },
//   footerText: { fontSize: 9, marginLeft: 4, color: "#fff" },
//   icon: { width: 30, height: 30, marginRight: 4 },
//   iconSmall: { width: 30, height: 30, marginRight: 3 },
// });

// export default TermsConditions;


// import React from "react";
// import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

// import logo from "../images/Helix logo.jpg";
// import webIcon from "../images/web.jpg";
// import phoneIcon from "../images/phone icon.jpg";
// import locationIcon from "../images/location icon.jpg";
// import messageIcon from "../images/message.jpg";

// // ✅ Pass products array as prop

// // ✅ Pass products array as prop
// const TermsConditions = ({ products }) => {
//   // calculate summary dynamically
//   let basicTotal = 0;
//   let packingTotal = 0;
//   let gstTotal = 0;

//   const rows = products.products.map((p, i) => {
//     const price = parseFloat(p.price || 0);
//     const packing = parseFloat(p.packing || 0);
//     const gstRate = parseFloat((p.gst || "0").replace("%", "")) / 100;

//     const gstAmount = (price + packing) * gstRate;

//     // accumulate totals
//     basicTotal += price;
//     packingTotal += packing;
//     gstTotal += gstAmount;

//     return [
//       `Basic Rate for Pit ${p.pitNo || i + 1}`,
//       `${price.toLocaleString()} INR`,
//     ];
//   });

//   const grandTotal = basicTotal + packingTotal + gstTotal;

//   // add packing, gst, grand total rows
//   const summaryRows = [
//     ...rows,
//     ["Packing & Forwarding", `${packingTotal.toLocaleString()} INR`],
//     [`GST ${products[0]?.gst || "18%"}`, `${gstTotal.toLocaleString()} INR`],
//     ["Grand Total", `${grandTotal.toLocaleString()} INR`],
//   ];

//   return (
//     <Page size="A4" style={styles.page}>
//       {/* Header */}
//       <View style={styles.header}>
//         <Image src={logo} style={styles.logo} />
//         <View style={styles.headerRight}>
//           <Image src={webIcon} style={styles.iconSmall} />
//           <Text style={styles.website}>sbsgroups.co.in</Text>
//         </View>
//       </View>

//       {/* Body */}
//       <View style={styles.body}>
//         {/* Quotation Summary */}
//         <View style={styles.table}>
//           {summaryRows.map(([label, value], i) => (
//             <View key={i} style={styles.row}>
//               <Text style={styles.cellLabel}>{label}</Text>
//               <Text style={styles.cellValue}>{value}</Text>
//             </View>
//           ))}
//         </View>

//         {/* Terms & Conditions */}
//         <Text style={styles.sectionTitle}>Terms & Conditions</Text>
//         <View style={styles.list}>
//           {terms.map((t, i) => (
//             <View key={i} style={styles.listItem}>
//               <Text style={styles.bullet}>•</Text>
//               <Text style={styles.listText}>{t}</Text>
//             </View>
//           ))}
//         </View>
//       </View>

//       {/* Footer */}
//       <View style={styles.footer}>
//         <View style={styles.footerSection}>
//           <Image src={phoneIcon} style={styles.icon} />
//           <View>
//             <Text style={styles.footerText}>8827559628</Text>
//             <Text style={styles.footerText}>9826808412</Text>
//           </View>
//         </View>

//         <View style={[styles.footerSection, styles.footerCenter]}>
//           <Image src={locationIcon} style={styles.icon} />
//           <Text style={styles.footerText}>
//             Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
//           </Text>
//         </View>

//         <View style={[styles.footerSection, styles.footerRight]}>
//           <Image src={messageIcon} style={styles.icon} />
//           <View>
//             <Text style={styles.footerText}>info@sbsgroups.co.in</Text>
//             <Text style={styles.footerText}>sales@sbsgroups.co.in</Text>
//           </View>
//         </View>
//       </View>
//     </Page>
//   );
// };

// const terms = [
//   "Offer validity: 30 Days from the date of submission, thereafter it will be subject to confirmation by us.",
//   "Prices: Quoted prices are Ex works. (our kathwada factory only)",
//   "Taxes: 18% GST applicable",
//   "P&F: 2% of basic amount",
//   "Transportation: Transportation charges will be in client scope, we are not responsible for damages if arranged by client.",
//   "Transit Insurance to be borne by client.",
//   "Payment Terms: 50% advance of total amount with GST along with PO, 50% of total amount against material readiness and Dispatch. (100% GST will be paid before dispatch)",
//   "Delivery period: 10 to 12 weeks from PO date and advance Payment received & Drawing Approval.",
//   "Installation: 3000/- Per Day, on-site civil work, Electric work, welding machine, drilling machine, hydra/fork lift, soft labor required will be in client scope.",
//   `Warranty: 
//    a) 12 months from the date of Invoice, we hereby warranty to replace free of cost Ex. Works Kathwada, any component found defective due to any manufacturing defects only. Bad workmanship will not be considered.
//    b) Warranty of bought-out product will remain the same as per company terms.
//    c) No warranty/Guarantee provided for electrical components. If any electrical failure occurs and due to this if any mechanical component fails, the same shall not be covered under warranty/guarantee and will be supplied only on chargeable basis.
//    d) In battery-operated equipment, battery charger will not be covered under warranty. Battery warranty will be 12 months.,
//    e) Once Order Placed not cancelled for any reason, if cancelled En􀆟re advance
// amount will be forfeited.
//  Civil Work Scope: Pit Alignment with Plaster in client Scope.
//  Electric work: Point for Panel & Underground wiring for Remote in Client
// Scope`
// ];

// const styles = StyleSheet.create({
//   page: {
//     padding: 25,
//     fontSize: 9,
//     fontFamily: "Helvetica",
//     backgroundColor: "#fff",
//     flexDirection: "column",
//   },
//   header: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     borderBottom: "2pt solid #b20000",
//     paddingBottom: 6,
//     marginBottom: 12,
//   },
//   logo: { width: 80, height: 80 },
//   headerRight: { flexDirection: "row", alignItems: "center" },
//   website: { fontSize: 11, color: "#b20000", fontWeight: "bold", marginLeft: 5 },

//   body: { flex: 1 },
//   table: { border: "1pt solid #000", marginBottom: 12 },
//   row: { flexDirection: "row", borderBottom: "1pt solid #000" },
//   cellLabel: {
//     width: "70%",
//     padding: 5,
//     borderRight: "1pt solid #000",
//     fontWeight: "bold",
//   },
//   cellValue: { width: "30%", padding: 5, textAlign: "right" },

//   sectionTitle: { fontSize: 11, fontWeight: "bold", marginVertical: 8 },
//   list: { flexDirection: "column" },
//   listItem: { flexDirection: "row", marginBottom: 4 },
//   bullet: { marginRight: 4, fontSize: 10 },
//   listText: { flex: 1, fontSize: 9, textAlign: "justify" },

//   footer: {
//     flexDirection: "row",
//     backgroundColor: "#b20000",
//     color: "#fff",
//     padding: 8,
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   footerSection: { flexDirection: "row", alignItems: "center", width: "30%" },
//   footerCenter: { width: "40%", textAlign: "center" },
//   footerRight: { justifyContent: "flex-end", textAlign: "right" },
//   footerText: { fontSize: 9, marginLeft: 4, color: "#fff" },
//   icon: { width: 30, height: 30, marginRight: 4 },
//   iconSmall: { width: 30, height: 30, marginRight: 3 },
// });

// export default TermsConditions;



import React from "react";
import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

// Images
import logo from "../../../../images/Final-logo-SBS.png"
import webIcon from "../../images/web.jpg";
import phoneIcon from "../../images/phone icon.jpg";
import locationIcon from "../../images/location icon.jpg";
import messageIcon from "../../images/message.jpg";

const TermsConditions = ({ leadInfo, quotation, products }) => {
  // Parse terms
  const parseTermsAndConditions = (termsString) => {
    if (!termsString) return [];
    return termsString
      .split(/\n+/)
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  };

  const terms = parseTermsAndConditions(quotation?.terms_conditions);

  const renderQuotationSummary = () => {
    if (!quotation) return null;

    return (
      <View style={styles.table}>
        {/* Quotation Date */}
        <View style={styles.row}>
          <Text style={styles.cellLabel}>Quotation Date:</Text>
          <Text style={styles.cellValue}>
            {quotation?.quotation_date
              ? new Date(quotation.quotation_date).toLocaleDateString("en-IN")
              : "N/A"}
          </Text>
        </View>

        {/* Products */}
        {products?.length > 0 &&
          products.map((product, index) => (
            <View key={index} style={styles.productRow}>
              <Text style={styles.productName}>
                {product.product_name && product.batch
                  ? `${product.product_name} - ${product.batch}`
                  : product.product_name || `Product ${index + 1}`}
              </Text>
              <Text style={styles.productValue}>
                {`${product.listprice || 0} × ${product.quantity || 0} = ${
                  (product.listprice || 0) * (product.quantity || 0)
                } INR`}
              </Text>
            </View>
          ))}

        {/* Subtotal */}
        <View style={styles.row}>
          <Text style={styles.cellLabel}>Subtotal:</Text>
          <Text style={styles.cellValue}>₹{quotation?.subtotal || "0.00"}</Text>
        </View>

        {/* Discount */}
        <View style={styles.row}>
          <Text style={styles.cellLabel}>Discount:</Text>
          <Text style={styles.cellValue}>
            {quotation?.discount || 0} {quotation?.discountType || ""}
          </Text>
        </View>

        {/* GST */}
        <View style={styles.row}>
          <Text style={styles.cellLabel}>GST Amount:</Text>
          <Text style={styles.cellValue}>₹{quotation?.gst || "0.00"}</Text>
        </View>

        {/* Total */}
        <View style={[styles.row, styles.grandTotalRow]}>
          <Text style={[styles.cellLabel, styles.grandTotalLabel]}>
            Total Amount:
          </Text>
          <Text style={[styles.cellValue, styles.grandTotalValue]}>
            ₹{quotation?.total_amount || "0.00"}
          </Text>
        </View>
      </View>
    );
  };

  return (
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        <Image src={logo} style={styles.logo} />
        <View style={styles.headerRight}>
          <Image src={webIcon} style={styles.iconSmall} />
          <Text style={styles.website}>sbsgroups.co.in</Text>
        </View>
      </View>

      {/* Body */}
      <View style={styles.body}>
        {/* Quotation Summary */}
        {quotation && (
          <View style={styles.quotationSummary}>
            <Text style={styles.summaryTitle}>Quotation Summary</Text>
            {renderQuotationSummary()}
          </View>
        )}

        {/* Terms & Conditions */}
        <Text style={styles.sectionTitle}>Terms & Conditions</Text>
        <View style={styles.list}>
          {(terms.length > 0 ? terms : defaultTerms).map((term, i) => (
            <View key={i} style={styles.listItem}>
              <Text style={styles.bullet}>•</Text>
              <Text style={styles.listText}>{term}</Text>
            </View>
          ))}
        </View>
      </View>

      {/* Footer */}
      <View style={styles.footer}>
        <View style={styles.footerSection}>
          <Image src={phoneIcon} style={styles.icon} />
          <View>
            <Text style={styles.footerText}>+91 8827559628</Text>
            <Text style={styles.footerText}>+91 9826808412</Text>
          </View>
        </View>

        <View style={[styles.footerSection, styles.footerCenter]}>
          <Image src={locationIcon} style={styles.icon} />
          <Text style={styles.footerText}>
            Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
          </Text>
        </View>

        <View style={[styles.footerSection, styles.footerRight]}>
          <Image src={messageIcon} style={styles.icon} />
          <View>
            <Text style={styles.footerText}>info@sbsgroups.co.in</Text>
            <Text style={styles.footerText}>sales@sbsgroups.co.in</Text>
          </View>
        </View>
      </View>
    </Page>
  );
};

// Default Terms
const defaultTerms = [
  "Offer validity: 30 Days from the date of submission, thereafter it will be subject to confirmation by us.",
  "Prices: Quoted prices are Ex works. (our kathwada factory only)",
  "Taxes: 18% GST applicable",
  "P&F: 2% of basic amount",
  "Transportation: Transportation charges will be in client scope, we are not responsible for damages if arranged by client.",
  "Transit Insurance to be borne by client.",
  "Payment Terms: 50% advance of total amount with GST along with PO, 50% of total amount against material readiness and Dispatch.",
  "Delivery period: 10 to 12 weeks from PO date and advance Payment received & Drawing Approval.",
  "Installation: 3000/- Per Day, on-site civil work, Electric work, welding machine, drilling machine, hydra/fork lift, soft labor required will be in client scope.",
  "Warranty: 12 months from the date of Invoice, covering manufacturing defects only.",
];

// Styles
const styles = StyleSheet.create({
  page: { padding: 25, fontSize: 10, fontFamily: "Helvetica", backgroundColor: "#fff" },
  header: {
    flexDirection: "row", justifyContent: "space-between", alignItems: "center",
    borderBottom: "2pt solid #b20000", paddingBottom: 6, marginBottom: 12
  },
  logo: { width: 80, height: 80 },
  headerRight: { flexDirection: "row", alignItems: "center" },
  website: { fontSize: 11, color: "#b20000", fontWeight: "bold", marginLeft: 5 },

  body: { flex: 1, justifyContent: "flex-start" },

  quotationSummary: { marginBottom: 12 },
  summaryTitle: { fontSize: 11, fontWeight: "bold", marginBottom: 8, textAlign: "center", color: "#b20000" },

  table: { border: "1pt solid #000", marginBottom: 12 },
  row: { flexDirection: "row", borderBottom: "1pt solid #000" },
  productRow: { flexDirection: "row", padding: 5, justifyContent: "space-between" },
  productName: { fontSize: 9 },
  productValue: { fontSize: 9 },

  cellLabel: { width: "50%", padding: 5, borderRight: "1pt solid #000", fontWeight: "bold", fontSize: 9 },
  cellValue: { width: "50%", padding: 5, textAlign: "right", fontSize: 9 },
  grandTotalRow: { backgroundColor: "#f0f0f0" },
  grandTotalLabel: { fontWeight: "bold", color: "#b20000" },
  grandTotalValue: { fontWeight: "bold", color: "#b20000" },

  sectionTitle: { fontSize: 11, fontWeight: "bold", marginVertical: 8, textDecoration: "underline", color: "#b20000" },
  list: { flexDirection: "column", marginBottom: 12 },
  listItem: { flexDirection: "row", marginBottom: 4, alignItems: "flex-start" },
  bullet: { marginRight: 4, fontSize: 10, color: "#b20000" },
  listText: { flex: 1, fontSize: 9, textAlign: "justify", lineHeight: 1.4 },

  footer: { flexDirection: "row", backgroundColor: "#b20000", color: "#fff", padding: 8, justifyContent: "space-between", alignItems: "center" },
  footerSection: { flexDirection: "row", alignItems: "center", width: "30%" },
  footerCenter: { width: "40%", textAlign: "center" },
  footerRight: { justifyContent: "flex-end", textAlign: "right" },
  footerText: { fontSize: 9, marginLeft: 4, color: "#fff" },
  icon: { width: 30, height: 30, marginRight: 4 },
  iconSmall: { width: 30, height: 30, marginRight: 3 },
});

export default TermsConditions;